import React, { PropTypes } from 'react';
import { Checkbox, RadioButton, Divider } from 'material-ui';
import { connect } from 'react-redux';
import R from 'ramda';
import {
  checkHonor as checkHonorAction,
  checkSameAsCorporate as checkSameAsCorporateAction,
} from '../__storeFiles__/actions';
import { policyNotesSections } from '../../../../utils/contracting-preset-names-codes';

const OverwriteRules = props => {
  const {
    style,
    honorPreloadContent,
    checkHonor,
    sameAsCorporatePolicyNotes,
    checkSameAsCorporate,
    classes = {},
  } = props;
  const availableSections = Object.keys(policyNotesSections);
  return (
    <div
      style={{
        width: '30%',
        borderLeft: '1px solid #efefef',
        padding: '16px',
        ...style,
      }}
    >
      <div className={classes.applyStepperLabel}>
        Step 2: Select the sections that should be applied to your templates
      </div>
      <Checkbox
        checked={availableSections.length === sameAsCorporatePolicyNotes.length}
        label="Select All"
        style={{ margin: '16px 0' }}
        onCheck={() => checkSameAsCorporate(
          availableSections.length === sameAsCorporatePolicyNotes.length
            ? []
            : availableSections
        )}
      />
      {
        availableSections.map(key => {
          const checked = R.contains(key, sameAsCorporatePolicyNotes);
          return (
            <Checkbox
              key={key}
              checked={checked}
              label={policyNotesSections[key]}
              onCheck={() => checkSameAsCorporate(
                checked
                  ? sameAsCorporatePolicyNotes.filter(str => str !== key)
                  : [...sameAsCorporatePolicyNotes, key],
              )}
            />
          );
        })
      }
      <Divider style={{ marginTop: '16px', marginBottom: '16px' }} />
      <div
        className={classes.applyStepperLabel}
      >
        Step 3: In the event that there are already policies or notes loaded in these sections
      </div>
      <RadioButton
        checked={!honorPreloadContent}
        label="Replace all sections with the Corporate Policies & Notes"
        style={{ margin: '16px 0' }}
        onCheck={() => checkHonor(false)}
      />
      <RadioButton
        checked={honorPreloadContent}
        label="Do not replace the pre-loaded information"
        style={{ margin: '16px 0' }}
        onCheck={() => checkHonor(true)}
      />
    </div>
  );
};

OverwriteRules.propTypes = {
  style: React.PropTypes.object,
  honorPreloadContent: React.PropTypes.bool,
  checkHonor: React.PropTypes.func,
  classes: React.PropTypes.object,
  sameAsCorporatePolicyNotes: PropTypes.array,
  checkSameAsCorporate: PropTypes.func,
};

const mapStateToProps = ({
    contracting: {
    masterTemplate: { applyMasterToTemplatesReducer },
  },
}) => {
  return {
    ...applyMasterToTemplatesReducer,
  };
};
export default connect(mapStateToProps, {
  checkSameAsCorporate: checkSameAsCorporateAction,
  checkHonor: checkHonorAction,
})(OverwriteRules);



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/apply-master-wizards/overwrite-rules.jsx